import React from "react";
import { Tab } from "semantic-ui-react";
import RiskThresholdMenu from "components/RiskThresholdMenu";

const tabs = [
  {
    menuItem: "MTM",
    pane: {
      key: "mtm",
      content: (
        <RiskThresholdMenu riskType="mtm" levels={["total", "instrument"]} />
      ),
    },
  },
  {
    menuItem: "VAR",
    pane: {
      key: "var",
      content: (
        <RiskThresholdMenu riskType="var" levels={["total", "instrument"]} />
      ),
    },
  },
  {
    menuItem: "CF",
    pane: {
      key: "cf",
      content: <RiskThresholdMenu riskType="cf" levels={["total"]} />,
    },
  },
];

const ThresholdForm = () => {
  return <Tab panes={tabs} renderActiveOnly={false} />;
};

export default ThresholdForm;
